<template>
  <div class="login">
    <div class="login__header">
      <IconGriLogo />
    </div>
    <div class="login__content" v-if="activeForm">
      <h1 class="login__title">Gricreative Form Oluşturma Sistemi</h1>
      <form class="login__form" v-on:submit.prevent>
        <span class="login__label">Kullanıcı Adınız</span>
        <FormInputLogin
          :placeholder="'Kullanıcı adınız...'"
          :minlength="3"
          v-model.trim="email"
          :rule="'[0-9a-zA-Z.-]+'"
          :endwith="endwith"
        />
        <FormButton :isloginpage="true" @action="login()" :text="'ŞİFRE GÖNDER'" :status="status" />
      </form>
    </div>
    <div class="login__content -response" v-else>
      <div class="login__response">
        <IconSuccess v-if="apiresult" />
        <IconError v-if="!apiresult" />

        <p
          v-if="apiresult"
          class="login__response__text"
        >Griform’a giriş linki mail adresinize gönderildi.</p>

        <p
          v-if="!apiresult"
          class="login__response__text"
        >Formunuz gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.</p>

        <button class="-login" @click="reSend()">TEKRAR GÖNDER</button>
      </div>
    </div>
    <div class="login__footer">© 2020 Gricreative. Tüm Hakları Saklıdır.</div>
  </div>
</template>

<script>
import { global } from "@/global";
import { login } from "@/services/login";

export default {
  data() {
    return {
      email: "",
      activeForm: true,
      apiresult: null,
      status: {
        loading: false,
        message: "",
        type: ""
      },
      endwith: global["ENDWITH"]
    };
  },
  methods: {
    login: async function() {
      let vm = this;

      vm.status.loading = true;

      let _email = `${vm.email}${vm.endwith}`;

      await login(_email)
        .then(response => {
          vm.activeForm = false;
          vm.apiresult = true;
          if (response.status.code != 200) vm.status.type = "error";
        })
        .catch(() => {
          vm.apiresult = false;
          vm.activeForm = false;
        });

      vm.status.loading = false;
    },
    reSend: function() {
      this.activeForm = true;
    }
  }
};
</script>